import React, { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  IconButton,
  Link,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  Divider,
  Checkbox,
  FormGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AttachFileIcon from "@mui/icons-material/AttachFile";
function SupplierTerms() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();

  const [fileName, setFileName] = useState("No file selected");

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFileName(event.target.files[0].name);
    } else {
      setFileName("No file selected");
    }
  };

  const [paymentAgain, setPaymentAgain] = React.useState("invoice");
  const [paymentType, setPaymentType] = React.useState("ap");
  const [advancePercentage, setAdvancePercentage] = React.useState("");
  const [dueDays, setDueDays] = React.useState("");
  const [initialPercentage, setInitialPercentage] = useState("");
  const [initialDueDays, setInitialDueDays] = useState("");
  const [deliveryOption, setDeliveryOption] = useState("delBalance");

  // State to track selected Prior Delivery option
  const [priorDelivery, setPriorDelivery] = useState("milestone");

  // Milestone Payment states
  const [milestoneNumber, setMilestoneNumber] = useState("");
  const [milestones, setMilestones] = useState([]);

  // Partial Schedule Payments states
  const [partialNumber, setPartialNumber] = useState("");
  const [payments, setPayments] = useState([]);

  // Installment Payment states
  const [installmentNumber, setInstallmentNumber] = useState("");
  const [paymentFrequency, setPaymentFrequency] = useState("w");
  const [installments, setInstallments] = useState([]);
  const [creditDaysType, setCreditDaysType] = useState("creditStatement"); // Default: Statement

  const [postGrnType, setPostGrnType] = useState("statement");

  const [supplierType, setSupplierType] = useState("c"); // Default: credit supplier

  // Handlers to update arrays based on number input
  const handleMilestoneNumberChange = (e) => {
    const val = e.target.value;
    setMilestoneNumber(val);
    const num = parseInt(val, 10);

    const finalNum = !isNaN(num) && num > 0 ? num : 1; // Ensure at least one
    const newArr = Array.from(
      { length: finalNum },
      (_, i) => milestones[i] || ""
    );
    setMilestones(newArr);
  };

  const handleMilestoneChange = (index, value) => {
    setMilestones((prev) => {
      const newArr = [...prev];
      newArr[index] = value;
      return newArr;
    });
  };

  const handlePartialNumberChange = (e) => {
    const val = e.target.value;
    setPartialNumber(val);
    const num = parseInt(val, 10);

    const finalNum = !isNaN(num) && num > 0 ? num : 1; // Ensure at least one
    const newArr = Array.from(
      { length: finalNum },
      (_, i) => payments[i] || ""
    );
    setPayments(newArr);
  };

  const handlePaymentChange = (index, value) => {
    setPayments((prev) => {
      const newArr = [...prev];
      newArr[index] = value;
      return newArr;
    });
  };

  const handleInstallmentNumberChange = (e) => {
    const val = e.target.value;
    setInstallmentNumber(val);
    const num = parseInt(val, 10);

    const finalNum = !isNaN(num) && num > 0 ? num : 1; // Ensure at least one
    const newArr = Array.from(
      { length: finalNum },
      (_, i) => payments[i] || ""
    );
    setInstallments(newArr);
  };

  const handleInstallmentChange = (index, value) => {
    setInstallments((prev) => {
      const newArr = [...prev];
      newArr[index] = value;
      return newArr;
    });
  };

  const getTimeUnitLabel = () => {
    switch (paymentFrequency) {
      case "week":
        return "Weeks";
      case "month":
        return "Months";
      default:
        return "Days";
    }
  };
  return (
    <>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{ ...styles.add_form_page_container, mb: 2 }}
      >
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
            <Typography sx={styles.supplier_sub_title_text}>
              Payment Methods :
            </Typography>
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}>
            <FormControl>
              {/* <FormLabel id="demo-row-radio-buttons-group-label">
                Select Payment Method
              </FormLabel> */}
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                size="small"
              >
                <FormControlLabel
                  value="cash"
                  control={<Radio size="small" />}
                  label="Cash"
                />
                <FormControlLabel
                  value="bank"
                  control={<Radio size="small" />}
                  label="Bank Transfer"
                />
                <FormControlLabel
                  value="cheque"
                  control={<Radio size="small" />}
                  label="Cheque"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        <Divider />

        <Grid container spacing={2} mt={4} mb={2}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
            // sx={{ display: "flex", alignItems: "center", gap: 2 }}
          >
            <Typography sx={styles.supplier_sub_title_text}>
              Payment Terms
            </Typography>
            {/* <Divider /> */}
          </Grid>

          <Grid
            container
            spacing={2}
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          >
            <Grid item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel>Supplier Type</InputLabel>
                <Select
                  label="Supplier Type"
                  defaultValue="c"
                  value={supplierType}
                  onChange={(e) => setSupplierType(e.target.value)}
                >
                  <MenuItem value="c">Credit Supplier</MenuItem>
                  <MenuItem value="n">Non-Credit Supplier</MenuItem>
                  {/* Add other countries as needed */}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Divider />

        {supplierType === "c" && (
          <Grid container spacing={2} mt={4} mb={2}>
            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
              <Typography sx={styles.supplier_sub_title_text}>
                Credit Period{" "}
              </Typography>
              {/* <Divider /> */}
            </Grid>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
              container
              spacing={2}
              // direction="column"
            >
              <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel>Credit Days</InputLabel>
                  <Select
                    label="Credit Days"
                    defaultValue="creditStatement"
                    value={creditDaysType}
                    onChange={(e) => setCreditDaysType(e.target.value)}
                  >
                    <MenuItem value="creditInvoice">Invoice Date </MenuItem>
                    <MenuItem value="creditGrn">GRN Date </MenuItem>
                    <MenuItem value="creditStatement">Statement </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item size={{ xs: 12, sm: 2, md: 2, lg: 2, xl: 2 }}>
                <TextField
                  label="Days"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="xx Days"
                  // required
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 2, md: 2, lg: 2, xl: 2 }}>
                <TextField
                  label="Grace Period"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="xx Days"
                  required
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 2, md: 2, lg: 2, xl: 2 }}>
                <TextField
                  label="Late Payment Interest %"
                  variant="outlined"
                  placeholder="%"
                  fullWidth
                  size="small"
                  required
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 2, md: 2, lg: 2, xl: 2 }}>
                <FormControl variant="outlined" fullWidth size="small">
                  {/* <InputLabel>Credit Days</InputLabel> */}
                  <Select defaultValue="c">
                    <MenuItem value="a">Per Day </MenuItem>
                    <MenuItem value="b">Per Month </MenuItem>
                    <MenuItem value="c">Per Annual </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        )}
        <Divider />

        <Grid container spacing={2} mt={4} mb={2}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
            // sx={{ display: "flex" }}
          >
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Payment"
                sx={{
                  // alignItems: "center",
                  "& .MuiFormControlLabel-label": {
                    fontSize: 14,
                    fontWeight: 400,
                  },
                }}
              />
            </FormGroup>

            <Typography sx={{ fontWeight: 400, fontSize: 12 }}>
              (Advance / Initial Payment)
            </Typography>
          </Grid>

          <Grid
            container
            spacing={2}
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          >
            {/* Advance Payment Section */}
            <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel>Payment</InputLabel>
                <Select label="Payment" defaultValue="a">
                  <MenuItem value="a">Advance Payment</MenuItem>
                  <MenuItem value="b">Initial Payment </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Percentage %"
                placeholder="%"
                value={advancePercentage}
                onChange={(e) => setAdvancePercentage(e.target.value)}
                // disabled={paymentType !== "ap"}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={dueDays}
                label="Due Days"
                placeholder="xx Days"
                onChange={(e) => setDueDays(e.target.value)}
                // disabled={paymentType !== "ap"}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* <Divider /> */}
        {supplierType === "n" && <Divider />}

        {/* at delivery grn */}
        {supplierType === "n" && (
          <Grid container spacing={2} mt={4} mb={2}>
            <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="At Delivery – GRN"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: 14,
                      fontWeight: 400,
                    },
                  }}
                />
              </FormGroup>
            </Grid>

            <Grid
              container
              spacing={2}
              size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel>At Delivery</InputLabel>
                  <Select
                    label="At Delivery"
                    value={deliveryOption}
                    onChange={(e) => setDeliveryOption(e.target.value)}
                    defaultValue="delBalance"
                  >
                    <MenuItem value="delBalance"> Balance Amount</MenuItem>
                    <MenuItem value="delCash">Cash on Delivery </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  label={
                    deliveryOption === "delBalance" ? "Balance %" : "Payment %"
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {/* at delivery end */}
        <Divider />

        {/*Prior deliver start  */}
        <Grid container spacing={2} mt={4} mb={2}>
          <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Prior Delivery"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: 14,
                    fontWeight: 400,
                  },
                }}
              />
            </FormGroup>
          </Grid>
          <Grid
            container
            spacing={2}
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          >
            {/*Milestone Payment Section */}
            <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel>Prior Delivery</InputLabel>
                <Select
                  label="Prior Delivery"
                  defaultValue="creditStatement"
                  value={creditDaysType}
                  onChange={(e) => setCreditDaysType(e.target.value)}
                >
                  <MenuItem value="milestonePayment">
                    Milestone Payment{" "}
                  </MenuItem>
                  <MenuItem value="partialSchedulePayments">
                    Partial Schedule Payments
                  </MenuItem>
                  <MenuItem value="installmentPayment">
                    Installment Payment{" "}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Number of Milestone"
                value={milestoneNumber}
                onChange={handleMilestoneNumberChange}
                type="number"
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
              {/* <FormControl component="fieldset" variant="standard" fullWidth> */}
              {/* <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  maxHeight: 400,
                  overflow: "auto",
                }}
              > */}
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel> Payment Frequency</InputLabel>
                <Select
                  label="Payment Frequency"
                  value={paymentFrequency}
                  onChange={(e) => setPaymentFrequency(e.target.value)}
                  defaultValue="w"
                >
                  <MenuItem value="week">Weekly</MenuItem>
                  <MenuItem value="month">Monthly</MenuItem>
                  <MenuItem value="customDate">Customize</MenuItem>
                </Select>
              </FormControl>
              {(milestones.length > 0 ? milestones : [""]).map(
                (value, index) => (
                  <Box key={index} sx={{ display: "flex", gap: 1 }}>
                    {/* {milestones.map((val, idx) => ( */}
                    <TextField
                      label={`Milestone ${index + 1} %`}
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={milestones[index] || ""}
                      onChange={(e) =>
                        handleMilestoneChange(index, e.target.value)
                      }
                      disabled={priorDelivery !== "milestone"}
                    />
                    <TextField
                      label="Days"
                      // type="number"
                      variant="outlined"
                      placeholder="xx Days"
                      size="small"
                      sx={{ width: 120 }}
                      value={milestones.days}
                      onChange={(e) =>
                        handleMilestoneChange(index, "days", e.target.value)
                      }
                      disabled={priorDelivery !== "milestone"}
                    />
                  </Box>
                )
              )}
              {/* </Box> */}
              {/* </FormControl> */}
            </Grid>
          </Grid>
        </Grid>
        {/*Prior deliver end  */}

        {supplierType === "c" && <Divider />}

        {supplierType === "c" && (
          <Grid container spacing={2} mt={4} mb={2}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
              // sx={{ display: "flex", alignItems: "center", gap: 2 }}
            >
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label=" At Delivery – GRN 1:"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: 14,
                      fontWeight: 400,
                    },
                  }}
                />
              </FormGroup>
              {/* <Typography sx={styles.supplier_sub_title_text}>
                At Delivery – GRN 1:
              </Typography> */}
            </Grid>

            <Grid
              container
              spacing={2}
              size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label="Cash on Delivery"
                  />
                </FormGroup>
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                <TextField
                  label="Payment %"
                  variant="outlined"
                  fullWidth
                  size="small"
                  required
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {supplierType === "c" && <Divider />}

        {supplierType === "c" && (
          <Grid container spacing={2} mt={4} mb={2}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
              // sx={{ display: "flex", alignItems: "center", gap: 2 }}
            >
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label=" At Delivery – GRN 2:"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: 14,
                      fontWeight: 400,
                    },
                  }}
                />
              </FormGroup>
              {/* <Typography sx={styles.supplier_sub_title_text}>
                At Delivery – GRN 2
              </Typography> */}
            </Grid>

            <Grid
              container
              spacing={2}
              size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
            >
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label="Credit Payment"
                  />
                </FormGroup>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                <TextField
                  label="Payment %"
                  variant="outlined"
                  fullWidth
                  size="small"
                  required
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                <TextField
                  label="Period"
                  variant="outlined"
                  placeholder="xx Days"
                  fullWidth
                  size="small"
                  required
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {creditDaysType === "creditStatement" && supplierType === "c" && (
          <Divider />
        )}
        {/*Post Grn Section start  */}

        {creditDaysType === "creditStatement" && supplierType === "c" && (
          // {supplierType === "c" && (
          <Grid container spacing={2} mt={4} mb={2}>
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
              // sx={{ display: "flex", alignItems: "center", gap: 2 }}
            >
              <Typography sx={{ fontWeight: 400, fontSize: 14 }}>
                Post GRN
              </Typography>
            </Grid>
            <Grid
              container
              spacing={2}
              size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
            >
              {/*Milestone Payment Section */}
              <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
                <FormControl component="fieldset" variant="standard" fullWidth>
                  <FormLabel
                    id="advance-payment-label"
                    sx={styles.labelText}
                    component="legend"
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Radio
                        size="small"
                        checked={postGrnType === "statement"}
                        onChange={() => setPostGrnType("statement")}
                        value="statement"
                        name="post-grn-type"
                      />
                      <Typography sx={{ fontSize: 14, fontWeight: 400 }}>
                        Statement Payment
                      </Typography>
                    </Box>
                  </FormLabel>

                  <Box
                    sx={{
                      mt: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      disabled={postGrnType !== "statement"}
                    >
                      <InputLabel> Statement Cycle</InputLabel>
                      <Select
                        label=" Statement Cycle"
                        // value={paymentFrequency}
                        // onChange={(e) => setPaymentFrequency(e.target.value)}
                        defaultValue="w"
                      >
                        <MenuItem value="w">Quarterly</MenuItem>
                        <MenuItem value="m">Monthly</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      disabled={postGrnType !== "statement"}
                    >
                      <InputLabel> Statement Date</InputLabel>
                      <Select
                        label=" Statement Date"
                        // value={paymentFrequency}
                        // onChange={(e) => setPaymentFrequency(e.target.value)}
                        defaultValue="w"
                      >
                        <MenuItem value="w">End Of Month</MenuItem>
                        <MenuItem value="m">Customize</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      size="small"
                      variant="outlined"
                      label="Payment Amount %"
                      value={partialNumber}
                      onChange={handlePartialNumberChange}
                      disabled={postGrnType !== "statement"}
                    />
                    <TextField
                      size="small"
                      variant="outlined"
                      label="Payment Due Date"
                      placeholder="xx Days"
                      value={partialNumber}
                      onChange={handlePartialNumberChange}
                      disabled={postGrnType !== "statement"}
                    />
                  </Box>
                </FormControl>
              </Grid>

              {/* partial schedule payments Section */}
              <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
                <FormControl component="fieldset" variant="standard" fullWidth>
                  <FormLabel
                    id="initial-payment-label"
                    sx={styles.disabledLabel}
                    component="legend"
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Radio
                        size="small"
                        checked={postGrnType === "partial"}
                        onChange={() => setPostGrnType("partial")}
                        value="partial"
                        name="post-grn-type"
                      />
                      <Typography>Partial Schedule Payments</Typography>
                    </Box>
                  </FormLabel>

                  <Box
                    sx={{
                      pt: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      maxHeight: 400,
                      overflow: "auto",
                    }}
                  >
                    <TextField
                      size="small"
                      variant="outlined"
                      label="Number of Payments"
                      type="number"
                      value={partialNumber}
                      onChange={handlePartialNumberChange}
                      disabled={postGrnType !== "partial"}
                    />

                    {(payments.length > 0 ? payments : [""]).map(
                      (value, index) => (
                        <Box key={index} sx={{ display: "flex", gap: 1 }}>
                          {/* {milestones.map((val, idx) => ( */}
                          <TextField
                            label={`Payment ${index + 1} %`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={payments[index] || ""}
                            onChange={(e) =>
                              handlePaymentChange(index, e.target.value)
                            }
                            disabled={postGrnType !== "partial"}
                          />
                          <TextField
                            label="Days"
                            // type="number"
                            variant="outlined"
                            size="small"
                            sx={{ width: 120 }}
                            placeholder="xx Days"
                            value={payments.days}
                            onChange={(e) =>
                              handlePaymentChange(index, "days", e.target.value)
                            }
                            // disabled={priorDelivery !== "partial"}
                          />
                        </Box>
                      )
                    )}
                  </Box>
                </FormControl>
              </Grid>

              {/* Installment Payment Section */}
              <Grid item size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
                <FormControl component="fieldset" variant="standard" fullWidth>
                  <FormLabel
                    id="initial-payment-label"
                    sx={styles.disabledLabel}
                    component="legend"
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Radio
                        size="small"
                        checked={postGrnType === "installment"}
                        onChange={() => setPostGrnType("installment")}
                        value="installment"
                        name="post-grn-type"
                      />
                      <Typography>Installment Payment</Typography>
                    </Box>
                  </FormLabel>

                  <Box
                    sx={{
                      pt: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      maxHeight: 400,
                      overflow: "auto",
                    }}
                  >
                    <TextField
                      size="small"
                      variant="outlined"
                      label="Number of Installment"
                      value={installmentNumber}
                      onChange={handleInstallmentNumberChange}
                      disabled={postGrnType !== "installment"}
                      type="number"
                      inputProps={{ min: 1 }}
                    />
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      disabled={postGrnType !== "installment"}
                    >
                      <InputLabel> Payment Frequency</InputLabel>
                      <Select
                        label="Payment Frequency"
                        value={paymentFrequency}
                        onChange={(e) => setPaymentFrequency(e.target.value)}
                        defaultValue="week"
                      >
                        <MenuItem value="week">Weekly</MenuItem>
                        <MenuItem value="month">Monthly</MenuItem>
                        <MenuItem value="customDay">Customize</MenuItem>
                      </Select>
                    </FormControl>

                    {(installments.length > 0 ? installments : [""]).map(
                      (value, index) => (
                        <Box key={index} sx={{ display: "flex", gap: 1 }}>
                          <TextField
                            label={`Payment ${index + 1} %`}
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={installments[index] || ""}
                            onChange={(e) =>
                              handleInstallmentChange(index, e.target.value)
                            }
                            disabled={postGrnType !== "installment"}
                          />

                          <TextField
                            label={getTimeUnitLabel()}
                            placeholder={`xx ${getTimeUnitLabel()}`}
                            variant="outlined"
                            size="small"
                            sx={{ width: 120 }}
                            value={installments[index]?.days || ""}
                            onChange={(e) =>
                              handleInstallmentChange(
                                index,
                                "days",
                                e.target.value
                              )
                            }
                          />
                        </Box>
                      )
                    )}
                  </Box>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        )}
        {/* )} */}
        {/*Post Grn Section end  */}
        {/*  */}
      </Box>

      <Box sx={styles.supplier_page_button_box}>
        <Button
          variant="outlined"
          size="medium"
          sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          size="medium"
          sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
        >
          Save
        </Button>
      </Box>
    </>
  );
}

export default SupplierTerms;
